export default __webpack_public_path__ + "assets/images/383c6d93fb778e891102b9a216430a57.svg";